export enum TypeExportContract {
    LikeAgency = 1,
    LikeOperator = 2,
    Teleselling = 3, // not used anymore
    PhoneCall = 4
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/typeExportContract.ts